module.exports = __webpack_public_path__ + "assets/img/btn-back-66f7ffed.png";